// import 'uno.css';
import '@/design/index.less';
import { createApp } from 'vue';
import type { App as InstanceVueType } from 'vue';
// 系统初始化
import '@/utils/hub';
import '@/utils-system/init-rely';
// app初始化
import { initApp } from '@/utils-system/init-app';
import App from './App.vue';
import '@/utils/http';

//vue3 项目 main.ts中

let app: InstanceVueType;

const bootstrap = async () => {
  app = createApp(App);
  await initApp(app);
  app.mount('#app');
};

bootstrap();
